import { ResizeSensor } from '../utils'
import throttle from 'lodash/throttle'


export default {
  inserted: function(el, binding, vnode) {
    binding.value()
    const throttled = throttle(binding.value, 300, { leading: false })
    vnode.sensor = new ResizeSensor(el, throttled)
  },
  unbind: function(el, binding, vnode) {
    
  }
}
